import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView, dateToView, timeToView } from '../../../utils/date.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { ThesisTypeApi } from '../../../api/thesis-type/thesis-type.api';
import UploadFile from '../../../components/upload/UploadFile';
import { RulesRegulationsApi } from '../../../api/rules-regulations/rules-regulations.api';
import { Box, Divider, IconButton, MenuItem, Typography } from '@mui/material';
import { ReactComponent as Document } from '../../../assets/icons/document.svg'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { CalendarPicker, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import thLocale from "date-fns/locale/th";
import { routeName } from '../../../routes/routeName';
import FilterSelect from '../../../components/select/filterSelect';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { ExaminationCalendarStudentApi } from '../../../api/examination-calendar-student/examination-calendar-student.api';
import StatusCustom from '../../../components/status/statusCustom';
import { renderStatus } from './enum/enum';
const defaultState = {
    id_thesis_type: 0,
    rules_regulations_name: undefined,
}
const dayOfWeekFormatter = (day: any) => {
    const days: any = {
        "จ.": "จันทร์",
        "อ.": "อังคาร",
        "พ.": "พุธ",
        "พฤ.": "พฤหัสบดี",
        "ศ.": "ศุกร์",
        "ส.": "เสาร์",
        "อา.": "อาทิตย์",
    };
    return days[day] || day;
};
export default function ListExaminationDate() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams();

    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [file, setFile] = useState<any>();
    const [tab, setTab] = useState<number>(0)
    const [date, setDate] = useState<any>(new Date());

    const [detail, setDetail] = useState<any>();
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [

        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ผู้ทำรายการ"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ระดับ"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("คณะ"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("วันที่จอง"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("วันที่ทำรายการ"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("สถานะ"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_examination_calendar_student, student_name, degree_name, faculty_name, examination_calendar_date, created_date, examination_calendar_student_status } =
            objData;

        const objRenderData = {
            key: id_examination_calendar_student,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: student_name,
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(examination_calendar_date),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(created_date),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <StatusCustom
                            sx={{ maxWidth: 200 }}
                            // white_space='nowrap'
                            text={renderStatus(examination_calendar_student_status)} type={''} />
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete

                            onViewClick={() => {
                                navigate(routeName.cms.DetaiExamination.replace(':id', `${id}`).replace(':id_examination_calendar_student', id_examination_calendar_student) + '?mode=VIEW')

                            }}

                            onEditClick={() => {
                                navigate(routeName.cms.DetaiExamination.replace(':id', `${id}`).replace(':id_examination_calendar_student', id_examination_calendar_student))
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_examination_calendar_student)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await ExaminationCalendarStudentApi.list(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setDetail(data.data?.detail_examination_calendar)
                setData(data?.data.list_student?.items);
                setPage(data?.data?.list_student?.meta.currentPage)
                setTotalItems(data?.data?.list_student?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,]);

    useEffect(() => {
        loadData();
    }, [loadData]);



    const handleDelete = async (id: any) => {
        await ExaminationCalendarStudentApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }


    return (
        <div>
            <div className='flex flex-col justify-start items-start'>
                <Typography variant='h3'>
                    {t('รายการขอจองวันสอบ ')}
                </Typography>
                <Typography sx={{marginTop:'20px'}}>
                    {`เรื่อง : ${detail?.examination_name} วันที่เริ่มต้น-สิ้นสุดกิจกรรม : ${dateToView(detail?.examination_start_date)} - ${dateToView(detail?.examination_end_date)} เวลาเริ่มต้น-สิ้นสุดกิจกรรม : ${timeToView(detail?.examination_start_date)} - ${timeToView(detail?.examination_end_date)} วันที่เริ่มต้น-สิ้นสุดการเปิดจอง : ${dateToView(detail?.examination_calendar_start_date)} - ${dateToView(detail?.examination_calendar_start_date)}`}
                </Typography>
            </div>


            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("MEETING.SEARCH_MEETING_NAME")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                        }}
                    // value={inputValueSearch.leave_type_name}
                    />


                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">

                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <InputDatePicker
                        helperText={""}
                        allowClear
                        disableFuture
                        onChange={(e: any) => {
                            // handleChangeValueSearch("date", moment(e).format("YYYY-MM-DD"));
                        }} value={undefined} />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">

                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>

            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1840}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>


        </div>
    )
}
